export var getDailyHours = function (startHours) {
    if (startHours === void 0) { startHours = 0; }
    var dailyHours = [];
    for (startHours; startHours < 24; startHours++) {
        dailyHours.push({
            id: startHours.toString(),
            name: ("0" + startHours).slice(-2) + ":00"
        });
    }
    return dailyHours;
};
//# sourceMappingURL=getDailyHours.js.map